export function formatMacroDate(value) {
    const date = toDate(value)
    if (!date) return "Unknown"
    return date.toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
    })
}

export function formatMacroDateTime(value) {
    const date = toDate(value)
    if (!date) return "Unknown"
    return date.toLocaleString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    })
}

function toDate(value) {
    if (!value) return null
    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return null
    return date
}
